import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Button, Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { handleStatusChange, handleDelete, handleStatusChangeForJoinWait } from '../../components/Common/ActiveStatusChange';
import { AvForm, AvField, AVFormGroup, AvRadio, AvRadioGroup } from "availity-reactstrap-validation";


import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import ActionsDropdown from '../../components/Common/DropDown';
import { BASE_URL, useJwtToken } from '../../components/Common/AppConfig';
import SetAlert from '../../components/Common/SetAlert';
import DataTable from 'react-data-table-component';
import { useHistory } from 'react-router-dom';
import DatePicker from "react-multi-date-picker";
import { useSelector } from 'react-redux';
import { CSVLink } from 'react-csv';
import Select from "react-select";
import moment from 'moment';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const JoinWaitlist = () => {

    const [userDetails, setUserDetails] = useState([]);
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [alertMessage, setAlertMessage] = useState({ success: '', error: '' });
    const [waitlist, setWiatliast] = useState([])
    const { id } = useParams("id")
    const [confirmModal, setConfirmModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [viewModal, setViewModal] = useState(false);
    const [selectedWaitlist, setSelectedWaitlist] = useState(null);

    const token = useJwtToken();

    const handleView = (row) => {
        setSelectedWaitlist(row);
        setViewModal(true);
    };

    const closeViewModal = () => {
        setViewModal(false);
        setSelectedWaitlist(null);
    };


    useEffect(() => {
        fetchEventDetails();

    }, []);

    const fetchEventDetails = async () => {
        try {
            const headers = {
                'Authorization': token,
                'Content-Type': 'application/json',
            };
            const response = await fetch(`${BASE_URL}/joinwaitlist/event/${id}`, {
                method: 'GET',
                headers: headers,
            });
            const data = await response.json();
            setWiatliast(data?.data)

        } catch (error) {
            setAlertMessage({ success: '', error: 'An error occurred while fetching event data' });
            console.error(error);
        }
    };



    const handleActiveClick = (row) => {
        setSelectedRow(row);
        setConfirmModal(true);
    }

    const confirmStatusChange = async () => {
        if (!selectedRow) return;
        setSubmitting(true)
        const Page_Url = `${BASE_URL}/joinwaitlist/status/${selectedRow._id}`;

        const status =
            selectedRow.status === "Pending"
                ? "Approved"
                : "Pending";

        const successMessageProp = "Status updated successfully.";
        const errorMessageProp = "Failed to update status.";
        try {

            await handleStatusChangeForJoinWait(
                status,
                selectedRow._id,
                Page_Url,
                fetchEventDetails,
                successMessageProp,
                errorMessageProp,
                setAlertMessage,
                token
            );
            setSubmitting(false)
            setConfirmModal(false);
            setSelectedRow(null);
        } catch (error) {
            setSubmitting(false)
        }

    };


    const handleAction = (action, row) => {
        if (action.toLowerCase() === 'status') {
            handleActiveClick(row);
        }
        if (action.toLowerCase() === 'attendee') {
            handleView(row);
        }

    };

    const renderActionsDropdown = (row) => (
        <ActionsDropdown
            row={row}
            toggleDropdown={toggleDropdown}
            handleAction={handleAction}
            status={true}
            allmenu={true}
            viewAttentessButton={true}
        />
    );

    const toggleDropdown = (row) => {
        row.dropdownOpen = !row.dropdownOpen;
        setDropdownOpen(!dropdownOpen);
        setUserDetails([...userDetails]);
    };



    let serialNumber = 1;
    const columns = [
        {
            name: "#",
            cell: (row, index) => index + 1,
            width: "70px",
        },
        {
            name: "Name",
            selector: row => row.name,
            sortable: true,
        },
        {
            name: "Email",
            selector: row => row.email,
            sortable: true,
        },
        {
            name: "Phone",
            selector: row => row.phone,
            sortable: true,
        },
        {
            name: "Company",
            selector: row => row.companyName,
            sortable: true,
        },
        {
            name: "Status",
            selector: row => row.status,
            sortable: true,
        },
        {
            name: "Action",
            cell: row => renderActionsDropdown(row),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];


    return (
        <div className="content">
            <Row>
                <Col md="12">
                    <Card>
                        <CardHeader>
                            <CardTitle tag="h4">Join Waitlist</CardTitle>
                        </CardHeader>
                        <CardBody>
                            <DataTable className='table-nowrap custom-data-table' columns={columns} data={waitlist} pagination highlightOnHover noHeader responsive keyField="_id" />
                        </CardBody>
                    </Card>

                </Col>
            </Row>


            <Modal isOpen={confirmModal} toggle={() => setConfirmModal(false)}>
                <ModalHeader toggle={() => setConfirmModal(false)}>
                    Confirm Status Change
                </ModalHeader>

                <ModalBody>
                    {selectedRow && (
                        <>
                            Are you sure you want to change the status of{" "}
                            <strong>{selectedRow.name}</strong> from{" "}
                            <strong>{selectedRow.status}</strong> to{" "}
                            <strong>
                                {selectedRow.status === "Pending"
                                    ? "Approved"
                                    : "Pending"}
                            </strong>
                            ?
                        </>
                    )}
                </ModalBody>

                <ModalFooter>
                    <Button
                        color="secondary"
                        onClick={() => setConfirmModal(false)}
                    >
                        Cancel
                    </Button>

                    <Button
                        color="primary"
                        onClick={confirmStatusChange}
                        disabled={submitting}
                    >
                        Yes, Update
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={viewModal} toggle={closeViewModal} size="md">
                <ModalHeader toggle={closeViewModal}>
                    Join Waitlist Details
                </ModalHeader>

                <ModalBody>
                    {selectedWaitlist && (
                        <Row>

                            <Col md="6" className="mb-3">
                                <strong>Name</strong>
                                <p>{selectedWaitlist.name}</p>
                            </Col>

                            <Col md="6" className="mb-3">
                                <strong>Email</strong>
                                <p>{selectedWaitlist.email}</p>
                            </Col>

                            <Col md="6" className="mb-3">
                                <strong>Phone</strong>
                                <p>{selectedWaitlist.phone}</p>
                            </Col>

                            <Col md="6" className="mb-3">
                                <strong>Company Name</strong>
                                <p>{selectedWaitlist.companyName || "-"}</p>
                            </Col>

                            <Col md="6" className="mb-3">
                                <strong>Company Website</strong>
                                <p>
                                    {selectedWaitlist.companyWebsite ? (
                                        <a
                                            href={selectedWaitlist.companyWebsite}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {selectedWaitlist.companyWebsite}
                                        </a>
                                    ) : (
                                        "-"
                                    )}
                                </p>
                            </Col>

                            <Col md="6" className="mb-3">
                                <strong>Company Founded</strong>
                                <p>
                                    {selectedWaitlist.companyFounded
                                        ? moment(selectedWaitlist.companyFounded).format("YYYY")
                                        : "-"}
                                </p>
                            </Col>

                            <Col md="6" className="mb-3">
                                <strong>LinkedIn</strong>
                                <p>
                                    {selectedWaitlist.linkedin ? (
                                        <a
                                            href={selectedWaitlist.linkedin}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {selectedWaitlist.linkedin}
                                        </a>
                                    ) : (
                                        "-"
                                    )}
                                </p>
                            </Col>

                            <Col md="6" className="mb-3">
                                <strong>Status</strong>
                                <p>

                                    {selectedWaitlist.status}
                                </p>
                            </Col>

                            <Col md="12" className="mb-3">
                                <strong>Message</strong>
                                <p>{selectedWaitlist.message || "-"}</p>
                            </Col>

                            <Col md="12">
                                <strong>Joined On</strong>
                                <p>
                                    {moment(selectedWaitlist.createdDate).format(
                                        "DD MMM YYYY, hh:mm A"
                                    )}
                                </p>
                            </Col>

                        </Row>
                    )}
                </ModalBody>

                <ModalFooter>
                    <Button color="secondary" onClick={closeViewModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}
export default JoinWaitlist